import {Component, OnInit} from '@angular/core';
import {LandingHeroBannerComponent} from '../../components/landing/landing-hero-banner/landing-hero-banner.component';
import {LandingFeatureComponent} from '../../components/landing/landing-feature/landing-feature.component';
import {LandingPricingComponent} from '../../components/landing/landing-pricing/landing-pricing.component';
import {
  LandingTestimonialsComponent
} from '../../components/landing/landing-testimonials/landing-testimonials.component';
import {Meta, Title} from '@angular/platform-browser';
import {TranslocoService} from '@jsverse/transloco';
import {HeaderComponent} from '../../../marketplace/components/header/header.component';
import {Footer} from '../../../core/components/footer/footer';

@Component({
  selector: 'app-landing',
  imports: [
    LandingHeroBannerComponent,
    LandingFeatureComponent,
    LandingPricingComponent,
    LandingTestimonialsComponent,
    HeaderComponent,
    Footer
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent implements OnInit {

  constructor(
    private readonly title: Title,
    private readonly meta: Meta,
    private readonly transloco: TranslocoService
  ) {}

  ngOnInit(): void {
    const lang = this.transloco.getActiveLang();

    this.transloco.selectTranslate('seo.manage.title').subscribe((title) => {
      this.title.setTitle(title);
      this.meta.updateTag({ name: 'title', content: title });
      this.meta.updateTag({ property: 'og:title', content: title });
    });

    this.transloco.selectTranslate('seo.manage.description').subscribe((description) => {
      this.meta.updateTag({ name: 'description', content: description });
      this.meta.updateTag({ property: 'og:description', content: description });
    });

    const ogImage = `https://shutterflow.io/assets/images/seo/manage/og-cover-${lang}.png`;

    this.meta.updateTag({ property: 'og:url', content: 'https://shutterflow.io/manage' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: ogImage });
  }
}
